/**
 * 修复 UTF-8 中文被误按 Latin-1 解码后的乱码（如 æ²³æ°´ç¨»é¦™ → 曲水稻香）。
 * 已是正常中文的字符串原样返回。
 */

function hasCjk(s) {
  return /[\u4e00-\u9fff]/.test(s);
}

/** 典型 mojibake：Latin-1 扩展字符为主，且不含正常中文 */
function looksLikeMojibake(s) {
  if (!s || typeof s !== 'string') return false;
  if (hasCjk(s)) return false;
  return /[\u0080-\u00ff]/.test(s) && /[æøåÄÖÜäöü]|[\u00c0-\u00ff]{2,}/.test(s);
}

export function repairUtf8Mojibake(input) {
  if (!input || typeof input !== 'string' || !looksLikeMojibake(input)) {
    return input;
  }
  try {
    const bytes = Uint8Array.from([...input].map((ch) => ch.charCodeAt(0) & 0xff));
    const repaired = new TextDecoder('utf-8', { fatal: true }).decode(bytes);
    if (hasCjk(repaired)) return repaired;
  } catch {
    /* fall through */
  }
  return input;
}

export function deepRepairUtf8Mojibake(value) {
  if (typeof value === 'string') return repairUtf8Mojibake(value);
  if (Array.isArray(value)) return value.map(deepRepairUtf8Mojibake);
  if (value && typeof value === 'object') {
    const out = {};
    for (const [k, v] of Object.entries(value)) {
      out[k] = deepRepairUtf8Mojibake(v);
    }
    return out;
  }
  return value;
}
